module.exports = __webpack_public_path__ + "static/img/Sex-Toys-for-Couples-nav-tile-900x1200.f626482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Sex-Toys-for-Couples-nav-tile-900x1200.jpg
// module id = Dx3m
// module chunks = 0